import axios from 'axios';
import { useSetRecoilState } from 'recoil';
import useApiClient from '~/src/hooks/useApiClient';
import { correlationAnalysisState } from '~/src/ProjectResults/store';
import { snackbarMessageSelector } from '~/src/Snackbar/store';

const useDetectCorrelationAnalysis = () => {
  // Hooks
  const apiClient = useApiClient();
  const setMessage = useSetRecoilState(snackbarMessageSelector);

  // Recoil State
  const setCorrelationAnalysisState = useSetRecoilState(
    correlationAnalysisState,
  );

  const handleDetectCorrelationAnalysis = async (
    projectId: number,
    target: string,
  ) => {
    try {
      setCorrelationAnalysisState((prev) => ({
        ...prev,
        isPending: true,
      }));
      await apiClient.put(
        `/automodeler/${projectId}/preprocess/detect-correlation-analysis`,
        {},
        { params: { target } },
      );
      // findOne(projectId);
    } catch {
      setCorrelationAnalysisState((prev) => ({
        ...prev,
        isPending: false,
      }));
    }
  };

  const getCorrelationAnalysisFile = async (projectId: number) => {
    try {
      setCorrelationAnalysisState((prev) => ({
        ...prev,
        fetchFilePending: true,
      }));
      const { data: url } = await apiClient.get(`/projects/${projectId}/urls`, {
        params: { file: 'correlation_analysis/correlation_results.json' },
      });
      const { data } = await axios.get(url);
      setCorrelationAnalysisState((prev) => ({
        ...prev,
        data: {
          ...(data || {}),
          top_features:
            data?.top_features?.filter(
              (item) => item?.['Likely Correlated'] === 'Yes',
            ) || [],
        },
      }));
    } catch (err) {
      if (err.response?.status && err.response?.status !== 404) {
        setMessage({
          message: 'Failed to fetch correlation analysis results',
          severity: 'error',
        });
      }
    } finally {
      setCorrelationAnalysisState((prev) => ({
        ...prev,
        fetchFilePending: false,
      }));
    }
  };

  return { handleDetectCorrelationAnalysis, getCorrelationAnalysisFile };
};

export default useDetectCorrelationAnalysis;
